import { useEffect, useState } from 'react'
import { useGlobalContext } from '../Context/Authentation';
import { toast } from 'react-toastify';
import axios from 'axios';

export default function UpdateNotes(props) {

    const { user, setrefresh, refresh } = useGlobalContext();
    const [title, settitle] = useState("");
    const [content, setcontent] = useState("");
    const [NoteId, setNoteId] = useState("");

    useEffect(() => {
        settitle(props?.title)
        setcontent(props?.content)
        setNoteId(props?.NoteId);
    }, [props?.title, props?.content, props?.NoteId])

    const SubmitHandler = async () => {
        if (!content || !title) {
            toast.warn('Please enter blank fileds', {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            return;
        }
        var toast1;
        try {
            toast1 = toast.loading("Updating Note", {
                position: "bottom-center",
                theme: "dark",
            })

            const config = { headers: { Authorization: `Bearer ${user?.token}` } }
            await axios.put(`https://quick-notes-c09v.onrender.com/api/notes/updateContent`, { noteId: NoteId, content: content, title: title }, config);
            settitle("")
            setcontent("")

            toast.update(toast1,
                {
                    render: "Note Updated",
                    type: "success",
                    isLoading: false,
                    position: "bottom-center",
                    autoClose: 5000,
                    theme: "dark",
                    closeOnClick: true,
                });

        } catch (error) {
            console.log(error);

            toast.update(toast1,
                {
                    render: "Unable to update Note",
                    type: "error",
                    isLoading: false,
                    position: "bottom-center",
                    autoClose: 5000,
                    theme: "dark",
                    closeOnClick: true,
                });

        }
        setrefresh(!refresh)
    }


    return (
        <div className="modal fade" id="UpdateNotes" tabIndex="-1" aria-labelledby="UpdateNotesLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5 text" id="UpdateNotesLabel" style={{ color: "black" }}>Update Existing Note</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">

                        <input type="text"
                            className="form-control"
                            placeholder='Add your Title'
                            value={title}
                            onChange={(e) => { settitle(e.target.value) }} />

                        <textarea type="text"
                            className="form-control mt-2"
                            placeholder='Type Your Note here...'
                            rows="5"
                            value={content}
                            onChange={(e) => { setcontent(e.target.value) }} />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" data-bs-dismiss="modal" className="btn btn-primary" onClick={SubmitHandler}>Update Note</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
